import React from 'react';
import styled from 'styled-components';
import SidebarLink from './SidebarLink';
/**
 * @deprecated - This component is due to be deleted Please remove from your mfe.
 */
export const StyledSecondaryLink = styled(SidebarLink) `
  overflow: hidden;
  padding: var(--layout-seed);
  padding-left: var(--layout-shoebox);
  border-radius: var(--border-r-stamp);
  max-height: 44px;
  margin-bottom: var(--layout-seed);

  &.active {
    color: var(--action-text-pressed);
  }

  &:hover {
    color: var(--action-text-hover);
  }
`;
export const SidebarSecondaryLink = ({ isActivePath, label, ...linkProps }) => {
    const modifiedLabel = label.includes(' ')
        ? label.toLowerCase().split(' ').join('-')
        : label.toLowerCase();
    return (React.createElement(StyledSecondaryLink, { ...linkProps, className: `dd-dashboard-sidebar-secondary-${modifiedLabel} ${isActivePath && 'active'}` }, label));
};
